export default __webpack_public_path__ + "static/dst-1948da18bc16be998c270c47bef9a051.png";